<template>
    <v-navigation-drawer
        temporary
        v-model="show"
        fixed
        right
        >
        <template v-if="user">
            <v-list class="pa-1">
                <v-list-item>
                    <v-list-item-avatar v-if="true||user.avatar">

                        <v-avatar
                            v-if="user.avatar"
                            size="40px"
                            tile
                            >
                            <img :src="user.avatar" :alt="user.name" />
                        </v-avatar>
                        <v-avatar  v-else
                                   size="40px"
                                   class="light-green"
                        >
                            <span class="white--text text-h5">{{user.name | charAvatar}}</span>
                        </v-avatar>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title v-text="user.name"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <!--- user panel menu-->
            <v-list class="pt-0" dense v-if="tab==='user-settings'">
                <v-divider></v-divider>
                <v-list-item @click="panelBack">
                    <v-list-item-action >
                        <v-icon>arrow_back_ios</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ trans('common.back') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-dialog
                    v-model="editPwdModal"
                    width="500"
                    :persistent="true"
                    >
                    <template v-slot:activator="{on}">
                        <v-list-item v-on="on" >
                            <v-list-item-action >
                                <v-icon>password</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                {{trans('userpanel.change-password.btn')}}
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                    <!--- --->

                    <edit-password @close="editPwdModal=false" @success="onChangePwd"></edit-password>
                </v-dialog>
            </v-list>
            <!--- Main menu -->
            <v-list class="pt-0" dense v-else>
              <!--
                <v-divider></v-divider>
                <v-list-item @click="">
                    <v-list-item-action>
                        <client-toggle></client-toggle>
                    </v-list-item-action>
                </v-list-item>
                -->

                <v-divider></v-divider>
                <v-list-item @click="userSettings" >
                    <v-list-item-action >
                        <v-icon>settings_applications</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ trans('userpanel.settings') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="logout" color="secondary" >
                    <v-list-item-action >
                        <v-icon>power_settings_new</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ trans('userpanel.logout') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </template>
        <template v-else>
            <v-list class="pa-1">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title >{{trans('userpanel.guest-title')}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-list class="pt-0" dense>
                <v-divider></v-divider>
                <v-list-item @click="login">
                    <v-list-item-action>
                        <v-icon>lock_open</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ trans('userpanel.login') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </template>

    </v-navigation-drawer>
</template>
<script>
import {mapState} from 'vuex';
import EditPassword from "./EditPassword";

export default {
        name: "user-panel",
        props: {
            value:{required:true}
        },
        data() {
            return {
                tab:'main',
                editPwdModal:false,
            }
        },
        mounted() {
        },
        computed: {
            show:{
                get(){return this.value;},
                set(v){this.$emit('input',v);console.log('userpane changed value to:',v);}
            },

            ...mapState(['user'])
        },
        methods: {
            onInput(v){this.$emit('input',v);},
            logout(){
                if(confirm(trans('userpanel.confirm-logout'))){
                    axios.post('/logout')
                        .finally(()=>{location.reload()})
                }
            },
            login(){
                location.href='/login';
            },
            userSettings(){
                this.tab='user-settings';
            },
            panelBack(){
                this.tab='main';
            },
            onChangePwd(r){
                if(r.redirect)
                    location.href=r.redirect;
                //this.editPwdModal=false;
            }
        },

        components: {
            EditPassword,
            ClientToggle:require('./ClientToggle').default,
        },
        filters: {
            charAvatar(s){return s.toUpperCase().substr(0,2);}
        }
    }
</script>
